import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import { setApiError } from "../../../admin/app-slice";
import {AppDispatch} from "../../../core/store";
import {ApiInstance} from "../../../services/api";
import {getKeyValueStringFromObj, getRegion, IGlobalFilter} from "../../../services/utils";
import {omit} from 'lodash'


interface RejectedOffers {
  number: string
  address: string
  reason: string
  age: number
  sex: string
  created_date: string
  creator: string
  executor: string
  name: string
  policy_number: string
  status: number
  insurance_org: string
  reject_reason: string
  reject_date: string
}

interface Rejects {
  rejectedOffers: Array<RejectedOffers>
  filter: IGlobalFilter,
  allDataLoaded: boolean
}

const initialState: Rejects = {
  rejectedOffers: [],
  filter: {
    limit: 50,
    offset: 0,
    q: '',
    from: '',
    to: '',
    data: {
      age: '',
    }
  },
  allDataLoaded: true
};

const rejectedOffers = createSlice({
  name: 'rejectedOffers',
  initialState: initialState,
  reducers: {
    setOffers: (state, action: PayloadAction<Array<RejectedOffers>>) => {
      state.rejectedOffers = action.payload
      return state
    },
    handleFilterChange: (state, action: PayloadAction<{key: string, value: any}>) => {
      const data = action.payload
      if (data.key.includes('data')) {
        const key: any = /\[([^)]*)]/.exec(data.key)![1] // reg-ex to get property from string
        state.filter.data![key] = data.value
      } else {
        state.filter[data.key] = data.value
      }
    },
    setDataLoaded: (state, action: PayloadAction<boolean>) => {
      state.allDataLoaded =  action.payload
    }
  }
});

export const {
  setOffers,
  handleFilterChange,
  setDataLoaded
} = rejectedOffers.actions;

export const getRejectedOffers = () => {
  return async (dispatch: AppDispatch, getState: any, api: ApiInstance) => {
    const {filter} = getState().rejectedOffers
    const { activeRegion } = getState().app
    const region = getRegion() || activeRegion.id !== 1 ? activeRegion.id : ''
    try {
      const additionalData = getKeyValueStringFromObj(filter.data)
      const updatedFilter = omit(filter, ['data'])
      const res = await api.request.get('/rejected-offers', {...updatedFilter,  offset: 0, region, filter: additionalData})
      dispatch(handleFilterChange({key: 'offset', value: 0}))
      res.length < filter.limit  ? dispatch(setDataLoaded(true)) : dispatch(setDataLoaded(false))
      dispatch(setOffers(res))
    } catch (e) {
      dispatch(setApiError(e))
    }
  }
};

export const loadMoreData = () => {
  return async (dispatch: AppDispatch, getState: any, api: ApiInstance) => {
    const {filter, rejectedOffers} = getState().rejectedOffers
    const { activeRegion } = getState().app
    const region = getRegion() || activeRegion.id !== 1 ? activeRegion.id : ''
    try {
      const additionalData = getKeyValueStringFromObj(filter.data)
      const updatedFilter = omit(filter, ['data'])
      const res = await api.request.get('/rejected-offers', {...updatedFilter, region, filter: additionalData})
      const updatedOffers = [...rejectedOffers, ...res]
      filter.limit > res.length && dispatch(setDataLoaded(true))
      dispatch(setOffers(updatedOffers))
    } catch (e) {
      dispatch(setApiError(e))
    }
  }
};

export default rejectedOffers.reducer;
